import cmkLogo from '../assets/CMK-logo.png'
import { waspContactInfo } from '../util/contactInfo';

const ContactFooter = ({waspPContent}) => (
  <div className="contact-footer">
    <div>
      <div className="wasp-title">CONTACT WASP{waspPContent ? '-P' : ''}:</div>
      {!waspPContent && <div>{waspContactInfo.tel}</div>}
      <div>{waspPContent ? 'aquatic.biodiversity@uhasselt.be' : 'wasp.uhasselt@gmail.com'}</div>
    </div>
    <img src={cmkLogo} alt={cmkLogo} />
  </div>
);

export default ContactFooter;

